import { gql } from 'apollo-angular';

const GET_STATUSES = gql`
    query GetStatuses { statuses }
`;

export default GET_STATUSES;
